import { render, staticRenderFns } from "./correct.vue?vue&type=template&id=5316402f&"
import script from "./correct.vue?vue&type=script&lang=ts&"
export * from "./correct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports